// The picture of a tree diagram: branches spreading left to right in one or
// two steps, each ending in its word. No numbers on the branches. Plain
// React SVG, like practice-graphs.tsx.

import {
  TREE_LABEL_SIZE,
  describeTreeDiagram,
  treeDiagramPicture,
  type TreeDiagramSpec,
} from './practice-tree-diagram-data';

const INK = '#2d4a3e';

const fixed = (value: number) => value.toFixed(2);

export function TreeDiagramView({ tree }: { tree: TreeDiagramSpec }) {
  const picture = treeDiagramPicture(tree);
  const { box, start } = picture;

  return (
    <figure className="m-0 max-w-md">
      <svg
        role="img"
        aria-label={describeTreeDiagram(tree)}
        viewBox={`${fixed(box.x)} ${fixed(box.y)} ${fixed(box.width)} ${fixed(box.height)}`}
        className="mx-auto block h-auto w-full"
        style={{ maxWidth: `${String(Math.round(box.width * 1.4))}px` }}
      >
        {picture.branches.map((branch, index) => (
          <line
            key={index}
            data-part={`step-${String(branch.step)}`}
            x1={fixed(branch.from.x)}
            y1={fixed(branch.from.y)}
            x2={fixed(branch.to.x)}
            y2={fixed(branch.to.y)}
            stroke={INK}
            strokeWidth="2"
            strokeLinecap="round"
          />
        ))}
        <circle
          data-part="start"
          cx={fixed(start.x)}
          cy={fixed(start.y)}
          r="3.2"
          fill={INK}
        />
        {picture.words.map((word, index) => (
          <text
            key={index}
            data-label={`step-${String(word.step)}`}
            x={fixed(word.x)}
            y={fixed(word.y)}
            dy="0.35em"
            textAnchor="start"
            fill={INK}
            fontSize={TREE_LABEL_SIZE}
            fontWeight="700"
          >
            {word.text}
          </text>
        ))}
      </svg>
    </figure>
  );
}
